var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpermaxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.444 3.663L36.804.02 1.534 35.312l3.64 3.643 35.27-35.292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09.008L1.519 3.58l35.419 35.44 3.57-3.572L5.09.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 0h-5.148v38.998H42V0zM5.166 0H.018v38.998h5.148V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v39H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpermaxLogo);
export default __webpack_public_path__ + "static/media/impermax-logo.9d1f4d05caa1f979670f88787907c01b.svg";
export { ForwardRef as ReactComponent };